import axios from '@/axios';
import coreIAMUrl from '@/apis/coreIAM'

export default {
    fetchProfile() {
        return axios.get(`${coreIAMUrl}/profile`)
    },
}